<template>
  <p :class="`error-text ${active ? 'active' : ''}`"><slot>{{ text }}</slot></p>
</template>

<script>
export default {
  name: 'error-text',
  props: {
    active: Boolean,
    text: String
  }
}
</script>

<style lang="scss">
.error-text {
  transition: margin 0.2s ease, opacity .2s, height 0.2s;
  font-size: 1rem;
  flex-basis: 100%;
  color: $error-color;
  font-weight: normal;
  height: 0;
  margin: 0;
  margin-left: -10px;
  white-space: pre-wrap;
  text-align: left;
  opacity: 0;

  &.active {
    height: auto;
    margin-bottom: 1rem;
    margin-left: 0;
    opacity: 1;
  }
}
</style>
